import './alignment.scss';

/**
 * Converts alignment values into data attributes for CSS alignment.
 *
 * @param direction - 'x' for horizontal alignment, 'y' for vertical alignment
 * @param alignment - The alignment value
 * @returns Object with data attributes for alignment
 *
 * @example
 * toAlignmentAttributes('x', 'center')
 * // Returns: { 'data-rev-alignment-x': 'center' }
 *
 * toAlignmentAttributes('y', 'start')
 * // Returns: { 'data-rev-alignment-y': 'start' }
 */
function toAlignmentAttributes(direction, alignment) {
    if (!alignment)
        return {};
    return {
        [`data-rev-alignment-${direction}`]: alignment,
    };
}

export { toAlignmentAttributes };
//# sourceMappingURL=alignment.js.map
